import type { ITimeRange } from '@common/validation/callBackMoment';
import { translateKey } from '@frontend/translate';

interface ITimeRangeReadProps {
    interval: ITimeRange;
}

export function TimeRangeRead(props: ITimeRangeReadProps) {
    return (
        <span>
            {props.interval.startTime ?? '-'}
            {` `}
            {translateKey('common.to')}
            {` `}
            {props.interval.endTime ?? '-'}
        </span>
    );
}
